import { Menu, Bell } from 'lucide-react';
import { ProfileMenu } from './ProfileMenu';
import { ThemeToggle } from './ThemeToggle';

interface HeaderProps {
  title?: string;
  onMenuClick?: () => void;
  user: {
    name: string;
    email: string;
    avatar?: string;
    role: string;
  } | null;
  notificationCount?: number;
}

export function Header({ title, onMenuClick, user, notificationCount = 0 }: HeaderProps) {
  return (
    <header 
      className="h-16 fixed top-0 right-0 left-[170px] z-40 flex items-center justify-between px-6"
      style={{
        backgroundColor: 'var(--background-card)',
        borderBottom: '1px solid var(--border-color)',
      }}
    >
      {/* 左側: モバイルメニュー、タイトル */}
      <div className="flex items-center gap-4">
        <button 
          className="md:hidden p-2 rounded-lg hover:bg-gray-100"
          onClick={onMenuClick}
        >
          <Menu size={20} />
        </button>
        {title && (
          <h1 
            className="text-lg font-semibold"
            style={{ color: 'var(--text-primary)' }}
          >
            {title}
          </h1>
        )}
      </div>

      {/* 右側: 通知、テーマ切替、プロフィール */}
      <div className="flex items-center gap-3">
        {/* テーマ切替 */}
        <ThemeToggle />

        {/* 通知 */}
        <button 
          className="relative p-2 rounded-lg transition-colors"
          style={{ color: 'var(--text-secondary)' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--light-gray-primary)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          <Bell size={20} />
          {notificationCount > 0 && (
            <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-medium">
              {notificationCount > 9 ? '9+' : notificationCount}
            </span>
          )}
        </button>

        {/* プロフィールメニュー */}
        {user && <ProfileMenu user={user} />}
      </div>
    </header>
  );
}
